import { mdiClose } from '@mdi/js'
import { AppIcon } from '../ui/icon'

interface TagBadgeProps {
    tag: { uid: string; name: string; color?: string; icon?: string }
    onRemove?: () => void
    compact?: boolean
    className?: string
}

function getContrastColor(hexColor: string): string {
    const r = parseInt(hexColor.slice(1, 3), 16)
    const g = parseInt(hexColor.slice(3, 5), 16)
    const b = parseInt(hexColor.slice(5, 7), 16)
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255
    return luminance > 0.5 ? '#000000' : '#ffffff'
}

export function TagBadge({ tag, onRemove, compact, className }: TagBadgeProps) {
    const bgColor = tag.color || '#6366f1'
    const textColor = getContrastColor(bgColor)

    return (
        <span
            data-testid="tag-badge"
            className={`inline-flex items-center gap-1 rounded-md border-0 font-medium ${compact ? 'px-1.5 py-0 text-[10px]' : 'px-2 py-0.5 text-xs'} ${className || ''}`}
            style={{ backgroundColor: bgColor, color: textColor }}
        >
            {tag.name}
            {onRemove && (
                <button
                    data-testid="tag-badge-remove"
                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); onRemove() }}
                    className="ml-0.5 rounded-full hover:opacity-80"
                    style={{ color: textColor }}
                >
                    {/* `text-current`, not the default `text-icon`: the badge
                        paints itself a per-tag background and picks the
                        readable ink inline, so the cross has to inherit that
                        rather than the muted token — on a saturated tag it is
                        otherwise invisible. */}
                    <AppIcon path={mdiClose} size="xs" className="text-current" />
                </button>
            )}
        </span>
    )
}
